import { UnorderedListOutlined } from '@ant-design/icons'
import type { ViewConfigSheet } from '@salescore/core'
// eslint-disable-next-line sonarjs/deprecation
import { useModal } from '@salescore/frontend-common'
import { Col, List, Modal, Row, Space } from 'antd'
import { t } from 'i18next'
import type { ReactElement } from 'react'

import { useCurrentFields } from '../../../../hooks/useCurrentFields'
import { KpiFormSheetFieldsFormItemSelectorTable } from './KpiFormSheetFieldsFormItemSelectorTable'
import { KpiFormSheetFieldsFormItemSorter } from './KpiFormSheetFieldsFormItemSorter'

export const KpiFormSheetFieldsFormItem = ({
  currentSheet,
  setCurrentSheet,
}: {
  currentSheet: ViewConfigSheet
  setCurrentSheet: (sheetConfig: ViewConfigSheet) => void
}): ReactElement => {
  // eslint-disable-next-line sonarjs/deprecation
  const modal = useModal()
  const currentFields = useCurrentFields()

  return (
    <div>
      <Space className="mb-3">
        <UnorderedListOutlined /> {t(`一覧表示時の項目（任意）`)}
      </Space>
      <List
        dataSource={currentFields}
        size="small"
        className="mb-8 cursor-pointer rounded border border-solid border-gray-200 p-2"
        renderItem={({ modelProperty, nodePathAsLabel }) => (
          <List.Item onClick={modal.showModal}>
            {nodePathAsLabel.join(': ')}: {modelProperty.label}
          </List.Item>
        )}
      />
      <Modal
        open={modal.isModalVisible}
        onCancel={() => {
          // onChange(values)
          modal.hideModal()
        }}
        width={'90%'}
        cancelText={t(`閉じる`)}
        okButtonProps={{ style: { display: 'none' } }}
        style={{ top: '3%' }}
      >
        <Row justify="space-between">
          <Col span={12} className="m-1 rounded-lg bg-gray-100 p-4">
            <KpiFormSheetFieldsFormItemSelectorTable
              currentFieldProperties={currentFields.map((x) => x.field.property)}
              currentSheet={currentSheet}
              setCurrentSheet={setCurrentSheet}
            />
          </Col>
          <Col span={11} className="m-1 rounded-lg bg-gray-100 p-4">
            <KpiFormSheetFieldsFormItemSorter
              currentFields={currentFields}
              currentSheet={currentSheet}
              setCurrentSheet={setCurrentSheet}
            />
          </Col>
        </Row>
      </Modal>
    </div>
  )
}
